export type PrivacyLine = { tag: string; body: string };
export type PrivacyFlow = { title: string; body: string };

export const PRIVACY_LINES: PrivacyLine[] = [
  {
    tag: "Dedicated microVM",
    body: "Each customer gets their own Fly.io Firecracker microVM with a dedicated 10GB volume. The same isolation tech AWS Lambda uses. One user per VM — never shared, never pooled.",
  },
  {
    tag: "Bring your own key",
    body: "Plug in your own OpenRouter key and pick whichever model you prefer (OpenAI, Anthropic, xAI). Your bill, your provider relationship. The agent never sees the raw key — a localhost proxy injects it per request.",
  },
  {
    tag: "Encrypted at rest",
    body: "Telegram session strings, OAuth tokens, and BYOK keys are AES-GCM encrypted in our central database. Your messages live on your VM's volume — never in the shared database.",
  },
  {
    tag: "Send is opt-in",
    body: "Telegram send is off by default — the agent reads, drafts, and surfaces, but you flip the switch before it can reply on your behalf. Per-tool toggles let you disable any specific action across every integration.",
  },
];

export const PRIVACY_FLOW: PrivacyFlow[] = [
  {
    title: "Telegram",
    body: "Your messages travel over Telegram's encrypted transport, the same as any normal client.",
  },
  {
    title: "Your Fly.io microVM",
    body: "Activated chats are stored in a per-user SQLite on your dedicated volume so the agent can recall context. Never written to our shared database.",
  },
  {
    title: "OpenRouter → your model",
    body: "LLM requests route through a localhost proxy that injects your OpenRouter key. The agent never sees the raw key. OpenRouter forwards to whichever provider you've picked.",
  },
];
